// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".obex-cookie-manage {\n  background-color: #f4f6f9;\n}\n\n.obex-cookie-manage .obex-cookie-content{\n  background-color: #fff;\n}\n\n.obex-cookie-manage .cookie-title{\n  display: block;\n  font-size: 2em;\n}\n\n.obex-cookie-manage .obex-cookie-card{\n  background-color: #f4f6f9;\n  border-radius: 7px;\n  border: 0;\n}\n\n.obex-cookie-manage .obex-cookie-card .card-title{\n  display: block;\n  font-size: 2em;\n}", ""]);
// Exports
module.exports = exports;
